import { FaFilePowerpoint, FaLink, FaFileWord, FaRegFileExcel, FaFilePdf, FaRegImage, FaFileDownload } from 'react-icons/fa';
import { BsMicrosoftTeams} from 'react-icons/bs';
import { CiMail } from 'react-icons/ci';

// getFileIcon fonksiyonu
export const getFileIcon = (fileName: string) => {
    const extension = fileName.split('.').pop()?.toLowerCase();
    switch (extension) {
        case 'xlsx':
            return <FaRegFileExcel />;
        case 'doc':
        case 'docx':
            return <FaFileWord />;
        case 'pdf':
            return <FaFilePdf />;
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
            return <FaRegImage />;
        case 'ppt':
        case 'pptx':
            return <FaFilePowerpoint />;
        case 'eml':
        case 'msg':
            return <CiMail />;
        case 'teams':
            return <BsMicrosoftTeams />;
        case 'html':
        case 'htm':
            return <FaLink />;
        default:
            return <FaFileDownload />;
    }
};
